import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthenticationResponse } from "@models/account/account.model";
import { AssetService } from "./asset.service";
import { catchError, map, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AssetTenantGuard implements CanActivate {
  private session: string = null;
  constructor(private router: Router, private assetService: AssetService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.session = localStorage.getItem("session");
    const accessToken = this.session
      ? (JSON.parse(this.session) as AuthenticationResponse)
      : null;
    return this.assetService.getByIdAndTenant(next.paramMap.get("id")).pipe(
      map((x: any) => {
        if (accessToken && x.res > 0) {
          return true;
        } else {
          if (x.res == 0) {
            this.router.navigate(["/assetsDropBox"]);
          } else {
            this.router.navigate(["/signIn"]);
          }
          return false;
        }
      }),
      catchError(() => {
        this.router.navigate(["/signIn"]);
        return of(false);
      })
    );
  }
}
